import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CommonService } from '../../common-service';
import { BookPrintResponse } from '../../responses/platform/book-print.response';

@Injectable({
  providedIn: 'root'
})
export class PublicSimulatorService extends CommonService {
  constructor(private http: HttpClient) {
    super();
  }

  public getActiveBookPrintsByPages(numPages: number): Observable<BookPrintResponse> {
    return this.http
      .get<BookPrintResponse>(
        environment.urlApiPlatform + "PublicSimulator/getAvaliable/pages/" + numPages, 
        this.addHeaderToken() // Usa o método base, se não tiver token, manda headers padrão
      )
      .pipe(catchError(this.handleError));
  }

  public getPublicConfig(): Observable<{ platformProfitPercent: number; baseTaxPercent: number; productionCostProfitMarginPercent: number }> {
    return this.http
      .get<{ platformProfitPercent: number; baseTaxPercent: number; productionCostProfitMarginPercent: number }>(
        environment.urlApiPlatform + "PublicSimulator/publicConfig",
        this.addHeaderToken()
      )
      .pipe(catchError(this.handleError));
  }
}
